export default "__VITE_ASSET__f6ccde1d__"